import { render, staticRenderFns } from "./pdf-render-annotation.html?vue&type=template&id=84ce5640&scoped=true&"
import script from "./pdf-render-annotation.js?vue&type=script&lang=js&"
export * from "./pdf-render-annotation.js?vue&type=script&lang=js&"
import style0 from "./pdf-render-annotation.scss?vue&type=style&index=0&id=84ce5640&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ce5640",
  null
  
)

export default component.exports